import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { loadUser, loadCompanyService } from "../reducers/models/setting";
import { load, loadListInRequest } from '../reducers/models/company/companyList';
import { load as loadWidget } from '../reducers/models/widget';
import { loadAll as loadAllMenuData } from '../reducers/models/menuData';
import { loadList as loadUserList } from '../reducers/models/user/userList';
import { loadUser as loadUserProject, loadObject as loadObjectProject, load as loadProject } from '../reducers/models/project/projectList';
import { unreadLoad as ticketUnreadLoad } from '../reducers/models/ticket';
import { companySet } from '../reducers/models/billing';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import ErrorAdd from "../util/ErrorAdd";

//ЗАГРУЗКА НЕОБХОДИМЫХ ДАННЫХ ДЛЯ ЗАПУСКА ПРИЛОЖЕНИЯ
function LoadFirstData() {

    const dispatch = useDispatch()

    //ПОДГРУЖАЕМ НЕОБХОДИМЫЕ ДАННЫЕ ДЛЯ ПЕРВОНАЧАЛЬНОГО ЗАПУСКА ПРИЛОЖЕНИЯ
    const stateSetting = useSelector((state) => state.setting);//Настройки приложения 
    const stateUserList = useSelector((state) => state.userList);//Пользователи
    const stateProjectList = useSelector((state) => state.projectList);//Проекты
    //const stateSubscription = useSelector((state) => state.subscription);//Подписка

    useEffect(() => {

        //Загружаем настройки пользователя
        if (stateSetting.user === null) {
            axios.get('/api_main/user/get')
                .then((res_user) => {
                    if (res_user.data.ID_Status === -1) {
                        return <Navigate to="/lk/user_blocked" replace />
                    }
                    else if (res_user.data.ID_Status === 0) {
                        return window.location.replace(process.env.REACT_APP_DOMAIN_MAIN + '/login?srv=' + process.env.REACT_APP_ID_SERVICE);
                    }
                    else {
                        dispatch(loadUser({ data: res_user.data.Data }));

                        //Настройки пользователя в компании указанного сервиса
                        if (stateSetting.companyService === null) {
                            axios.get('/api_main/user/settingCompanyServiceGet', { params: { ID_Service: process.env.REACT_APP_ID_SERVICE } })
                                .then((res) => {

                                    dispatch(loadCompanyService({ data: res.data.Data }));

                                    if (res.data.Status === -1) {
                                        return <Navigate to="/lk/user_blocked" replace />
                                    }
                                    else {
                                        /*
                                        ID	Name
                                        -1	Нет доступа
                                        0	Владелец
                                        1	Администратор
                                        2	Пользователь
                                        */
                                        const id_role = res.data.Data.ID_Role;

                                        //Если админ или владелец, то подгружаем статус компании
                                        if (id_role === 0 || id_role === 1) {
                                            axios.get('/api_tracker/billing/companyGet')
                                                .then((res) => {
                                                    dispatch(companySet({ data: res.data.Data }));
                                                })
                                                .catch((err) => {
                                                    ErrorAdd(err, window.location.href);
                                                });
                                        }
                                    }
                                })
                                .catch((err) => {
                                    ErrorAdd(err, window.location.href);
                                });
                        }
                        //Компании       
                        axios.get('/api_main/company/list', { params: { ID_Status: 1 } })
                            .then((comp) => {
                                axios.get('/api_main/company/externalList', { params: { ID_Service: process.env.REACT_APP_ID_SERVICE } })
                                    .then((extComp) => {
                                        dispatch(load({ company: comp.data.Data, companyExternal: extComp.data.Data }));
                                    })
                                    .catch((err) => {
                                        ErrorAdd(err, window.location.href);
                                    });
                            })
                            .catch((err) => {
                                ErrorAdd(err, window.location.href);
                            });

                        //Виджеты
                        axios.get('/api_tracker/widget/list')
                            .then((res) => {
                                dispatch(loadWidget({ list: res.data.Data }));
                            })
                            .catch((err) => {
                                ErrorAdd(err, window.location.href);
                            });
                        //Данные для меню
                        axios.get('/api_tracker/other/menuCounterGet')
                            .then((res) => {
                                dispatch(loadAllMenuData({ data: res.data.Data }));
                            })
                            .catch((err) => {
                                ErrorAdd(err, window.location.href);
                            });
                        //Пользователи
                        if (stateUserList.list_loaded === false) {
                            axios.get('/api_main/company/userServiceList', { params: { ID_Service: process.env.REACT_APP_ID_SERVICE } })
                                .then((res) => {
                                    dispatch(loadUserList({ data: res.data.Data, id_status: 1 }));
                                })
                                .catch((err) => {
                                    ErrorAdd(err, window.location.href);
                                });
                        }
                        //Проекты
                        if (stateProjectList.listLoaded.filter(a => a.id_status === 1).length === 0) {
                            axios.get('/api_tracker/project/list', { params: { ID_Status: 1 } })
                                .then((res) => {
                                    dispatch(loadProject({ list: res.data.Data, id_status: 1 }));
                                })
                                .catch((err) => {
                                    ErrorAdd(err, window.location.href);
                                });
                        }
                        //Связка проект-пользователь
                        if (stateProjectList.listUserLoaded.filter(a => a.id_status === 1).length === 0) {
                            axios.get('/api_tracker/project/userList', { params: { ID_Status: 1 } })
                                .then((res) => {
                                    dispatch(loadUserProject({ list: res.data.Data, id_status: 1 }));
                                })
                                .catch((err) => {
                                    ErrorAdd(err, window.location.href);
                                });
                        }
                        //Связка проект-объект
                        if (stateProjectList.listObjectLoaded.filter(a => a.id_status === 1).length === 0) {
                            axios.get('/api_tracker/project/objectList', { params: { ID_Status: 1 } })
                                .then((res) => {
                                    dispatch(loadObjectProject({ list: res.data.Data, id_status: 1 }));
                                })
                                .catch((err) => {
                                    ErrorAdd(err, window.location.href);
                                });
                        }
                        //Входящие заявки
                        axios.get('/api_main/company/requestInList', { params: { ID_Service: process.env.REACT_APP_ID_SERVICE } })
                            .then((res) => {
                                dispatch(loadListInRequest({ data: res.data.Data }));
                            })
                            .catch((err) => {
                                ErrorAdd(err, window.location.href);
                            });

                        //Список не прочитанных сообщений по тикетам
                        axios.get('/api_tracker/ticket/unreadList')
                            .then((res) => {
                                if (res.data.Status === 1) {
                                    dispatch(ticketUnreadLoad({ data: res.data.Data }));
                                }
                            })
                    }
                })
                .catch((err) => {
                    ErrorAdd(err, window.location.href);
                    return window.location.replace(process.env.REACT_APP_DOMAIN_MAIN + '/login?srv=' + process.env.REACT_APP_ID_SERVICE);
                });;
        }

    }, []);
}

export default LoadFirstData;